// extracted by mini-css-extract-plugin
var _1 = "XIzFE";
var _2 = "YU7OL";
export { _1 as "base", _2 as "remove" }
